import {
  FieldValues,
  useForm,
  UseFormGetValues,
  UseFormRegister,
  UseFormSetValue
} from 'react-hook-form';
import { usePostMutation, usePutMutation } from '../../../../hooks/use-mutations';
import { MapLayer } from '../../types/map-layer';
import { useNavigate, useParams } from 'react-router';
import { useQuery } from '../../../../hooks/use-query';
import React, { useEffect } from 'react';
import { alert } from '../../../../components/toast/toast';

type Props = {
  children: (params: ChildProps) => JSX.Element;
};

export type ChildProps = {
  register: UseFormRegister<FieldValues>;
  getValues: UseFormGetValues<any>;
  setValue: UseFormSetValue<any>;
  changedFields?: string[];
  errors?: any;
};

export const Changed = (): JSX.Element => <span className="changed-notify">Changed</span>;

export const MapLayerEditorContainer = (props: Props): JSX.Element => {
  const params = useParams();
  const navigate = useNavigate();
  const id = params.id as string;
  const { register, handleSubmit, getValues, setValue, formState: { errors } } = useForm();
  const postMutation = usePostMutation<MapLayer>({ path: '/map-layers' });
  const putMutation = usePutMutation<MapLayer>({ path: `/map-layers/${id}`, cacheKey: `/map-layers/${id}` });
  const mapLayer = useQuery<MapLayer>({ path: `/map-layers/${id}`, options: { enabled: id !== 'new' } });

  useEffect(() => {
    if (postMutation.isSuccess) {
      alert.success('Layer crated successfully');
    }
  }, [postMutation.isSuccess]);

  useEffect(() => {
    if (putMutation.isSuccess) {
      alert.success('Layer updated successfully');
    }
  }, [putMutation.isSuccess]);

  const onSubmit = (data: FieldValues): void => {
    id === 'new' ? postMutation.mutate(data) : putMutation.mutate(data);
  };

  useEffect(() => {
    if (mapLayer.data?.id) {
      setExistingValues();
    }
  }, [mapLayer.data]);

  useEffect(() => {
    if (postMutation.data?.id) {
      navigate(`/map-layers/${postMutation.data.id}`);
    }
  }, [postMutation.isSuccess]);

  const setExistingValues = (): void => {
    for (const key in mapLayer.data) {
      if (key === 'changedFields') {
        continue;
      }
      setValue(key, mapLayer.data[key as keyof MapLayer]);
    }
  };

  return <>
    <form id="current-form" onSubmit={handleSubmit(onSubmit)}>
      {props.children({ register, getValues, setValue, errors, changedFields: mapLayer.data?.changedFields })}
    </form>
  </>;
};
